import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProject } from "../../../model/model";

interface IProjectsState {
  currentProjectSizeInMbs?: number;
  list: IProject[];
}

const initialState: IProjectsState = {
  currentProjectSizeInMbs: 0,
  list: [],
};

export const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setCurrentProjectSizeInMbs: (state: IProjectsState, action: PayloadAction<number>) => {
      state.currentProjectSizeInMbs = action.payload;
    },
    clearProjects: (state: IProjectsState) => {
      state.list = [];
    },
  },
});

export const { clearProjects, setCurrentProjectSizeInMbs } = projectSlice.actions;

export default projectSlice.reducer;
